import instance from './base';

// 系統設定（管理站，限 admin）：key-value，PUT 只更新有帶的 key。
// 驗證失敗回 400 { error: 'invalid_inputs', key, detail }

/**
 * @returns {Promise<{settings: Object<string, string>, updated_at: ?number, updated_by: ?string}>}
 */
export async function getSystemSettings() {
  const rsp = await instance.get('/v1/system-settings');
  return rsp.data;
}

/**
 * @param {Object<string, string>} settings 要更新的 key-value
 * @returns {Promise<{settings: Object<string, string>, updated_at: ?number, updated_by: ?string}>}
 */
export async function updateSystemSettings(settings) {
  const rsp = await instance.put('/v1/system-settings', { settings });
  return rsp.data;
}
